/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import FormField, { CustomFormFieldProps } from './FormField'
import { NumberInput, NumberInputProps } from '@mantine/core'
import { stringParser } from '../../../lib/form'
import { parseNumber } from '@jalik/form-parser'

export type FormNumberFieldProps = CustomFormFieldProps<NumberInputProps>

function FormNumberField (props: FormNumberFieldProps) {
  const { name, ...others } = props
  stringParser()
  return (
    <FormField
      thousandSeparator=" "
      formatter={null}
      parser={parseNumber}
      {...others}
      name={name}
      render={NumberInput}
    />
  )
}

export default FormNumberField
